import { findClientsWithDeparturesBySellerCompanyGroupedDate } from '../../_services/client.service';

export const findSellerDeparturesGroupedDateEvent = async () => {
    let res = await findClientsWithDeparturesBySellerCompanyGroupedDate();
    if(! res.ok) throw new Error(res.error);
    return res;
}